import { render, staticRenderFns } from "./AgentView.vue?vue&type=template&id=3def2645&"
import script from "./AgentView.vue?vue&type=script&lang=ts&"
export * from "./AgentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports